import React from 'react';
import { FaApple, FaFacebook, FaGooglePlay, FaTiktok } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { PLATFORM } from '../config/platform';

const year = new Date().getFullYear();

function Footer() {
  return (
    <footer className="footer py-4" style={{ background: 'black', color: 'white', textAlign: 'center' }}>
      <div className="container mb-5">
        <div className="row justify-content-center">
          <div className="col-md-3 mt-2">
            <h5>Play and connect</h5>
            <ul className="list-unstyled">
              <li><Link to="/find-pool-players-near-me" className="text-white">Find pool players nearby</Link></li>
              <li><Link to="/organize-pool-matches" className="text-white">Organize a real pool match</Link></li>
              <li><Link to="/billiards-community" className="text-white">Billiards social network</Link></li>
              <li><Link to="/pool-teams" className="text-white">Pool teams</Link></li>
              <li><Link to="/pool-tournaments-near-me" className="text-white">Pool tournaments</Link></li>
            </ul>
          </div>
          <div className="col-md-3 mt-2">
            <h5>Tools and places</h5>
            <ul className="list-unstyled">
              <li><Link to="/pool-practice-room" className="text-white">P4R Practice Room</Link></li>
              <li><Link to="/pool-scorekeeper" className="text-white">Advanced Race Room</Link></li>
              <li><Link to="/pool-match-tracker" className="text-white">Pool match tracker</Link></li>
              <li><Link to="/pool-halls-near-me" className="text-white">Pool halls near me</Link></li>
              <li><Link to="/pool-hall-management" className="text-white">Pool hall business tools</Link></li>
              <li><Link to="/buy-sell-pool-equipment" className="text-white">Pool equipment marketplace</Link></li>
            </ul>
          </div>
          <div className="col-md-3 mt-2">
            <h5>Official apps</h5>
            <p>Pool 4 Real connects real players, venues and competition with advanced Android Practice Room and Race Room tools across supported platforms.</p>
            <p><a href={PLATFORM.ios.url} target="_blank" rel="noopener noreferrer" className="text-white"><FaApple /> App Store</a></p>
            <p><a href={PLATFORM.android.url} target="_blank" rel="noopener noreferrer" className="text-white"><FaGooglePlay /> Google Play</a></p>
            <Link to="/download" className="text-white">Download Pool 4 Real</Link>
          </div>
          <div className="col-md-3 mt-2">
            <h5>Help and policies</h5>
            <ul className="list-unstyled">
              <li><Link to="/support" className="text-white">Support</Link></li>
              <li><Link to="/privacy" className="text-white">Privacy Policy</Link></li>
              <li><Link to="/termsofservice" className="text-white">Terms of Service</Link></li>
              <li><Link to="/adpolicy" className="text-white">Advertising Policy</Link></li>
              <li><Link to="/delete-account" className="text-white">Delete Account</Link></li>
              <li><Link to="/child-safety-standards" className="text-white">Child Safety Standards</Link></li>
            </ul>
            <div className="d-flex justify-content-center mt-3">
              <a href="https://www.tiktok.com/@pool4real" aria-label="Pool 4 Real on TikTok" className="text-white me-4"><FaTiktok size={28} /></a>
              <a href="https://www.facebook.com/people/Pool-4-Real/61558102206785" aria-label="Pool 4 Real on Facebook" className="text-white"><FaFacebook size={28} /></a>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-4"><div className="col-md-12 mb-5"><p>&copy; {year} Pool 4 Real. A pool and billiards social, training, competition, and player platform.</p></div></div>
      </div>
    </footer>
  );
}

export default Footer;
